module.exports = __webpack_public_path__ + "media/images/flags/4x3/hmd-4050b3f5921dd63c2e2dd8cdf3703975.svg";